var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content warehouse-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("CargoMsg.Cargo_CreateBillsPayable"),
        width: "1200px",
        "close-on-click-modal": false,
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c("tab-bill-payment-jc", {
            ref: "bpPage",
            attrs: { "page-source": "financeAp", "application-status": 9 }
          })
        ],
        1
      ),
      _c("hr"),
      _c("div", { staticStyle: { "margin-bottom": "10px", display: "flex" } }, [
        _c(
          "div",
          { staticStyle: { "padding-right": "75%" } },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: { click: _vm.mergeGeneratePay }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MergeGeneratePay")))]
            )
          ],
          1
        ),
        _c(
          "div",
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.generatePay } },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_GeneratePay")))]
            ),
            _c(
              "el-button",
              {
                on: {
                  click: function($event) {
                    _vm.innerVisible = false
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("Pricing.Cancel")))]
            )
          ],
          1
        )
      ]),
      _vm.detailDialog.visible
        ? _c("payable-detail-dialog", {
            attrs: {
              visible: _vm.detailDialog.visible,
              action: _vm.detailDialog.action,
              "merge-type": _vm.detailDialog.mergeType,
              uuids: _vm.detailDialog.uuids,
              title: _vm.detailDialog.title
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.detailDialog, "visible", $event)
              },
              saveResult: _vm.saveHandler
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }